<template>
  <div>
    <div class="lighter d-inline-block">{{ $t('Visibility') }}</div>
    <info-helper class="ml-1" text="stateSetterHint"/>
    <select
        v-model="selected"
        class="custom-select"
        :disabled="readOnly"
    >
      <option v-for="(key, item, index) in possibleStates"
              :key="index"
              :value="key">
        {{ $t(key) }}
      </option>
    </select>
  </div>
</template>

<script>
import {contentTypes, ProjectStates, AssetStates, InstanceStates} from '@/enum';
import InfoHelper from "@/components/InfoHelper.vue";

export default {
  name: "StateSetter",
  components: {InfoHelper},
  props: {
    targetId: {type: String, required: true},
    storeName: {type: String, required: true},
    givenState: {type: String, default: 'a'},
    readOnly: {type: Boolean, default: false}
  },
  data() {
    return {
      possibleStates: [],
      ProjectStates,
      AssetStates,
      InstanceStates,
      selected: ''
    };
  },
  watch: {
    selected(val) {
      this.setState(val);
    },
    givenState(val) {
      this.selected = val;
    }
  },
  beforeMount() {
    if (this.givenState) {
      this.selected = this.givenState;
    }
    const type = contentTypes[this.storeName.toLowerCase()];
    const states = this[`${type}States`];
    if(this.selected === this.AssetStates.PROCESSING) {
      this.possibleStates = this[`${type}States`];
    } else {
      this.possibleStates = this.removeProcessingState(states);
    }
  },
  methods: {
    removeProcessingState(items) {
      let finalObj = {};
      const keys = Object.keys(items);
      for(let i = 0; i < keys.length; i++) {
        if(items[keys[i]] !== this.AssetStates.PROCESSING) {
          finalObj[keys[i]] = items[keys[i]];
        }
      }
      return finalObj;
    },
    setState(state) {
      if (this.givenState !== state) {
        this.$store.dispatch(`update${this.storeName}`, {
          id: this.targetId,
          state: state
        }).then(() => {
          this.$emit('setState', state);
        })
      }
    }
  }
}
</script>

<style scoped>

</style>